import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import { Loader2 } from 'lucide-react';

const SellCarPage = () => {
  const navigate = useNavigate();
  const { user, token, loading } = useAuth();

  useEffect(() => {
    if (loading) return; // wait for auth context to hydrate
    if (user || token) {
      navigate('/dashboard/add-car', { replace: true });
    } else {
      navigate('/login?next=/dashboard/add-car', { replace: true });
    }
  }, [user, token, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="sell-car-redirect">
      <Loader2 className="w-6 h-6 animate-spin text-cyan-500" />
    </div>
  );
};

export default SellCarPage;
